import { DataService } from '../dataService';
export const aiConfigService = {
  getAIConfig: (contentId) => {
    return DataService.get(`ai-config/${contentId}`);
  },
  updateAIConfig: (data) => {
    return DataService.put(`ai-config`, data);
  },
};
